import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import SvgIcon from '../../SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.12 7.784c.682-.472 1.53-1.06 1.53-2.284 0-1.462-1.413-2.65-3.15-2.65-1.737 0-3.15 1.188-3.15 2.65 0 .276.224.5.5.5h.3c.276 0 .5-.224.5-.5 0-.732.847-1.35 1.85-1.35 1.003 0 1.85.618 1.85 1.35 0 .518-.351.786-.97 1.216-.586.405-1.294.896-1.482 1.802-.052.249.138.482.392.482h.38c.244 0 .456-.152.555-.375.134-.301.443-.528.895-.841M7.5 10.1c-.497 0-.9.403-.9.9s.403.9.9.9.9-.403.9-.9-.403-.9-.9-.9M7.5 0C3.358 0 0 3.358 0 7.5 0 11.642 3.358 15 7.5 15c4.142 0 7.5-3.358 7.5-7.5C15 3.358 11.642 0 7.5 0m0 1.2c3.474 0 6.3 2.826 6.3 6.3 0 3.474-2.826 6.3-6.3 6.3-3.474 0-6.3-2.826-6.3-6.3 0-3.474 2.826-6.3 6.3-6.3M0 15V0m15 15V0",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 0v20M0 0v20M10 5C8.313 5 6.906 6.022 6.574 7.384c-.077.314.164.616.487.616h.509c.217 0 .418-.133.484-.339C8.265 7.005 9.071 6.5 10 6.5c1.084 0 2 .687 2 1.5 0 .448-.315.701-1.035 1.172-.596.39-1.373.898-1.629 1.794-.091.318.152.634.482.634h.533c.199 0 .38-.118.458-.301.121-.284.434-.516.977-.872C12.51 9.954 13.5 9.305 13.5 8c0-1.657-1.567-3-3.5-3m0-3c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8m0 1.5c3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5-6.5-2.916-6.5-6.5S6.416 3.5 10 3.5m.9 9.6v.8c0 .276-.224.5-.5.5h-.8c-.276 0-.5-.224-.5-.5v-.8c0-.276.224-.5.5-.5h.8c.276 0 .5.224.5.5",
  fillRule: "evenodd"
});

export default function QuestionIcon(props) {
  return React.createElement(SvgIcon, _extends({
    viewBox: function viewBox(size) {
      return size < 20 ? '0 0 15 15' : '0 0 20 20';
    }
  }, props), function (size) {
    return size < 20 ? _ref : _ref2;
  });
}
QuestionIcon.displayName = 'QuestionIcon';